<template>
  <v-dialog
    :value="value" @input="$emit('input')"
    width="800"
  >

    <v-card>
      <v-card-title class="text-h5">
        Copy Paymethods: {{ items.length }}
      </v-card-title>

      <v-card-text>
        <select-project
          v-model="entity_ids"
          :multiple="true"
          required
          :return-object="false"
        ></select-project>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          color="warning"
          text
          @click.native="$emit('input')"
        >
          Close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="save"
          :disabled="entity_ids.length == 0"
        >
          Copy
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
</style>

<script>

  import { API } from '@/utils/api'
  import { map } from 'lodash'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    props: {
      entity_id: { default: false },
      value: { default: false },
      items: { default: () => ({}) },
    },

    components: { SelectProject },

    data: () => ({
      entity_ids: []
    }),

    methods: {
      async save () {
        if (this.items.length == 0 || this.entity_ids.length == 0) {

          this.$notification.show = true
          this.$notification.message = `Paymethods or destination not selected`
          this.$notification.type = 'warning'
          return
        }

        if (!await this.$root.$confirm('Confirm', 'Copy paymethods')) {
          return
        }

        this.loading = true
        return API.call('/$v/paymethod/copy.json', { entity_ids: this.entity_ids, paymethods: this.items }, null, { entity_id: this.items[0].entity_id }).then(resp => {

          this.$notification.show = true
          this.$notification.message = 'Paymethods copied'
          this.$notification.type = 'success'

          this.$emit('input')
        }).finally(() => {
          this.loading = false
        })
      },
    }
  }
</script>
